import React from 'react';

type Props = {
  title: React.ReactNode;
  description?: React.ReactNode;
};

export default function ContentTitle({ title, description }: Props) {
  return (
    <div>
      <h3 className="text-[24px] font-bold leading-[140%] tracking-[-0.48px] text-apps-coreGray01 lg:text-[clamp(24px,3vw,36px)] lg:leading-[120%] lg:tracking-[-0.72px]">
        {title}
      </h3>
      <p className="mt-[8px] text-[16px] font-medium leading-[140%] tracking-[-0.32px] text-apps-brandGray200 lg:text-[clamp(16px,1.667vw,20px)] lg:leading-[160%] lg:tracking-[-0.4px]">
        {description}
      </p>
    </div>
  );
}
